import React from "react"

import Button from "../Button"

const Form = ({ type = "image", styles, children }) => {
  return (
    <div
      className={`${
        type === "image"
          ? "bg-[url(images/footer.webp)] border-b-[3px] border-b-white"
          : "bg-transparent"
      } flex justify-center`}
    >
      <div className="flex flex-col items-center mt-11 w-11/12 md:w-8/12 lg:mx-auto lg:w-auto">
        {children}
        <form className="m-0 flex flex-col font-ubuntu text-[14px] font-light text-black w-full">
          <input
            className={`${
              type !== "image" ? "border-[1px] border-black" : ""
            } mb-[17px] py-[11px] px-[16px]`}
            type="text"
            placeholder="Name"
          />
          <input
            className={`${
              type !== "image" ? "border-[1px] border-black" : ""
            } mb-[17px] py-[11px] px-[16px]`}
            type="text"
            placeholder="Email"
          />
          <textarea
            className={`${
              type !== "image" ? "border-[1px] border-black" : ""
            } pl-[16px] pt-[12px]`}
            cols="56"
            rows="5"
            placeholder="Your Message"
          />
        </form>

        <Button color="blue" size="xs" styles={"pt-[41px] mb-[100px]"}>
          Send
        </Button>
      </div>
    </div>
  )
}

export default Form
